export default __webpack_public_path__ + "static/media/public.712fa120.png";